export default "__VITE_ASSET__c842e2f7__"